"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.MetaText = exports.MetaContainer = exports.Meta = exports.InnerContainer = exports.ImgPortrait = exports.ImgLandscape = exports.Icon = exports.Container = exports.Chevron = exports.BackgroundContainer = exports.ArrowContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
`;
exports.Container = Container;
const MetaContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
`;
exports.MetaContainer = MetaContainer;
const Meta = _styledComponents.default.p`
  line-height: 1em;
  font-weight: normal;
  margin-top: 30px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'univers-regular', sans-serif;
  color: ${props => {
  return props.color?.hex || 'inherit';
}};
  text-transform: ${props => props.typeface === 'black' || props.typeface === 'condensed' ? 'uppercase' : 'capitalize'};

  ${(0, _typography.setFontSizes)({
  xs: '14px',
  sm: '14px'
})}
`;
exports.Meta = Meta;
const MetaText = _styledComponents.default.p`
  margin-top: 10px;
  margin-bottom: 0;
  text-transform: uppercase;
  line-height: 1em;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'univers-regular', sans-serif;
  color: ${props => {
  return props.color?.hex || 'inherit';
}};

  a.link {
    color: ${props => {
  return props.color?.hex || 'inherit';
}};
    border-color: ${props => {
  return props.color?.hex || 'inherit';
}};
    text-decoration: none;
    transition: border-bottom 0.3s;
    border-bottom: 0;

    &:hover {
      border-bottom: 1px solid;
    }
  }
`;
exports.MetaText = MetaText;
const Title = _styledComponents.default.h1`
  line-height: 1em;
  font-weight: normal;
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${props => {
  let fontProps = {};
  if (props.typeface === 'black') {
    fontProps.headline = true;
  } else if (props.typeface === 'deville') {
    fontProps.display = true;
  } else if (props.typeface === 'condensed') {
    fontProps.condensed = true;
  }
  return (0, _typography.setFont)({
    ...fontProps
  });
}}

  color: ${props => {
  return props.color?.hex || 'inherit';
}};
  text-transform: ${props => props.typeface === 'black' || props.typeface === 'condensed' ? 'uppercase' : 'capitalize'};

  ${(0, _typography.setFontSizes)({
  xs: '30px',
  sm: '48px',
  xl: '60px'
})}

  @media (min-width: 768px) {
    max-width: 75vw;
  }

  @media (min-width: 1200px) {
    max-width: 60vw;
  }
`;
exports.Title = Title;
const ImgPortrait = _styledComponents.default.img`
  padding: 0px 24px;
  max-width: 540px;
  width: 100%;

  @media (min-width: 992px) {
    display: none;
  }
`;
exports.ImgPortrait = ImgPortrait;
const ImgLandscape = _styledComponents.default.img`
  @media (min-width: 992px) {
    max-width: 80vw;
  }
  @media (min-width: 1200px) {
    max-width: 80vw;
  }
  @media (max-width: 991px) {
    display: none;
  }
`;
exports.ImgLandscape = ImgLandscape;
const InnerContainer = _styledComponents.default.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 0px 24px;
  display: flex;
  /* padding-top: 32px;
  padding-bottom: 32px; */
  box-sizing: border-box;

  /* @media (min-width: 768px) {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  @media (min-width: 1200px) {
    padding-top: 64px;
    padding-bottom: 64px;
  } */
  ${props => {
  const {
    verticalAlignment,
    horizontalAlignment
  } = props;
  let alignItems, justifyContent, textAlign;
  switch (verticalAlignment) {
    case 'top':
      alignItems = 'flex-start';
      break;
    case 'bottom':
      alignItems = 'flex-end';
      break;
    case 'center':
      alignItems = 'center';
      break;
    default:
      alignItems = 'center';
      break;
  }
  switch (horizontalAlignment) {
    case 'left':
      justifyContent = 'flex-start';
      textAlign = 'left';
      break;
    case 'right':
      justifyContent = 'flex-end';
      textAlign = 'right';
      break;
    case 'center':
      justifyContent = 'center';
      textAlign = 'center';
      break;
    default:
      justifyContent = 'center';
      textAlign = 'center';
      break;
  }
  return `
        align-items: ${alignItems};
        justify-content: ${justifyContent};
        text-align: ${textAlign};
    `;
}}

  ${(0, _layout.setContainer)({
  size: 'xl'
})}

  @media (max-width: 767px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;
exports.InnerContainer = InnerContainer;
const BackgroundContainer = _styledComponents.default.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url('${props => props.backgroundImage?.src}');
  background-size: cover;
  background-position: center center;

  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${props => props.blackOverlay && `rgba(0, 0, 0, 0.35)`};
  }
`;
exports.BackgroundContainer = BackgroundContainer;
const ArrowContainer = _styledComponents.default.div`
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%);
  animation: fade-out 1.5s infinite;
  opacity: 0.7;

  @keyframes fade-out {
    0% {
      opacity: 0.7;
      bottom: 30px;
    }
    100% {
      opacity: 0;
      bottom: 3px;
    }
  }
`;
exports.ArrowContainer = ArrowContainer;
const Icon = _styledComponents.default.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none'
})``;
exports.Icon = Icon;
const Chevron = (0, _styledComponents.default)(Icon)`
  transform: rotate(90deg);
  width: 32px;
  height: 32px;
`;
exports.Chevron = Chevron;
//# sourceMappingURL=styles.js.map